import * as React from "react";
import { commonClientResx } from "~/resxDist/commonClientResx";
import { icon, Icon } from "../icons";

export const CustomFieldMarker: React.FC<Partial<React.ComponentProps<typeof Icon>>> = props => (
    <Icon iconName={icon.custom_field} title={commonClientResx.custom_field_label} {...props} />
);
